module.exports = __webpack_public_path__ + "static/img/IL@3x.d98d38c7.jpg";